// Work's extra columns belong to this business on this device, like the
// welcome checklist's per-business choice. No customer details are stored.
export function addressOneLine(address: string | null | undefined): string {
  return (address ?? '').replace(/\s+/g, ' ').trim()
}

function storageKey(businessId: number | null | undefined): string | null {
  return typeof businessId === 'number' && Number.isSafeInteger(businessId) && businessId > 0
    ? `roundly:work-columns:${businessId}` : null
}

// Old or unrecognised fields never add a column, even if storage was edited
// by hand. The picker supplies its fields so there is only one allowed list.
export function columnChoices(value: unknown, allowed: readonly string[]): Set<string> {
  return new Set(Array.isArray(value) ? value.filter((field): field is string =>
    typeof field === 'string' && allowed.includes(field)) : [])
}

export function readWorkColumns(businessId: number | null | undefined, allowed: readonly string[]): Set<string> {
  try {
    const key = storageKey(businessId)
    return key ? columnChoices(JSON.parse(localStorage.getItem(key) ?? '[]'), allowed) : new Set()
  } catch {
    return new Set()
  }
}

export function writeWorkColumns(businessId: number | null | undefined, choices: ReadonlySet<string>, allowed: readonly string[]): void {
  try {
    const key = storageKey(businessId)
    if (key) localStorage.setItem(key, JSON.stringify([...columnChoices([...choices], allowed)]))
  } catch {
    // Private window or full storage: the current visit keeps its choices.
  }
}
